import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Modal, Spin } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';

import { useUpdateFAQMutation } from '@/api/endpoints/mainPages';
import { DataSection, InputField } from '@/shared/components';
import { useApiRequest } from '@/shared/hooks';

import { FAQ_VALIDATION_SCHEMA } from '../../consts';
import type { IFAQItemData, IFormData } from '../../types';

import styles from './FAQModals.module.scss';

interface IProp {
  pageId: number;
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  handleClearOperateItem: VoidFunction;
  itemToOperate: IFAQItemData;
}

export const EditFAQModal = ({ pageId, isModalOpen, handleCancel, itemToOperate }: IProp) => {
  const [updateFAQ, { isLoading: isFAQUpdating }] = useUpdateFAQMutation();

  const sendApiRequest = useApiRequest();

  const methods = useForm<IFormData>({
    defaultValues: {
      question: itemToOperate ? itemToOperate.question : '',
      answer: itemToOperate ? itemToOperate.answer : '',
    },
    resolver: yupResolver(FAQ_VALIDATION_SCHEMA),
  });

  const { handleSubmit } = methods;

  const handleUpdateFAQ = handleSubmit(({ question, answer }) => {
    sendApiRequest({
      successMessage: 'Вопрос успешно изменён',
      apiRequestCallback: () =>
        updateFAQ({
          mainPageId: pageId,
          FAQId: itemToOperate.id,
          data: {
            question,
            answer,
          },
        }),
      successCallback: handleCancel,
    });
  });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={isFAQUpdating}>
        <div className={styles.wrapper}>
          <FormProvider {...methods}>
            <p className={styles.title}>Изменение вопроса</p>
            <div className={styles['content-wrapper']}>
              <DataSection
                titleText="Текст вопроса"
                isTitleRequired
              >
                <InputField
                  fieldName="question"
                  placeholder="Текст"
                  shouldEnableLengthCounter
                  maxLengthCount={200}
                />
              </DataSection>
              <DataSection
                titleText="Ответ на вопрос"
                isTitleRequired
              >
                <InputField
                  fieldName="answer"
                  placeholder="Текст"
                  shouldEnableLengthCounter
                  maxLengthCount={500}
                />
              </DataSection>
            </div>
            <div className={styles['buttons-wrapper']}>
              <Button
                size="large"
                onClick={handleCancel}
                className={styles.button}
                danger
              >
                Отмена
              </Button>
              <Button
                size="large"
                onClick={handleUpdateFAQ}
                type="primary"
                className={styles.button}
                disabled={isFAQUpdating}
              >
                Сохранить
              </Button>
            </div>
          </FormProvider>
        </div>
      </Spin>
    </Modal>
  );
};
